/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReviewCreateDto } from '../../models/review-create-dto';
import { ReviewDto } from '../../models/review-dto';

export interface ReviewAdminControllerCreateV1$Params {
      body: ReviewCreateDto
}

export function reviewAdminControllerCreateV1(http: HttpClient, rootUrl: string, params: ReviewAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ReviewDto>> {
  const rb = new RequestBuilder(rootUrl, reviewAdminControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReviewDto>;
    })
  );
}

reviewAdminControllerCreateV1.PATH = '/api/v1/reviews/admin';
